import React from "react";
import ReactTooltip from "react-tooltip";
import SegmentedToggle from "../common/segmentedToggle";

export interface AutoSyncSettingsStepProps {
  enableAutoSync: boolean;
  setEnableAutoSync: (value: boolean) => void;
}

const AutoSyncSettingsStep = ({
  enableAutoSync,
  setEnableAutoSync,
}: AutoSyncSettingsStepProps) => (
  <div>
    <p>
      Control whether DonorPerfect data syncs automatically every 30 minutes.
    </p>
    <SegmentedToggle
      title="Enable Auto Sync"
      value={enableAutoSync ? "on" : "off"}
      options={[
        { value: "on", label: "On" },
        { value: "off", label: "Off" },
      ]}
      onChange={value => setEnableAutoSync(value === "on")}
      showInfo={true}
      infoId="AutoSyncSettings"
    />
    <ReactTooltip
      id="tpAutoSyncSettings"
      type="info"
      place="bottom"
      effect="float"
    >
      When enabled, DonorPerfect donor and gift data syncs every 30 minutes.
    </ReactTooltip>
  </div>
);

export default AutoSyncSettingsStep;
